import {
  GET_CURRENCY_LIST,
  GET_CURRENCY_LIST_FAILURE,
  GET_CURRENCY_LIST_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const getCurencyListReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CURRENCY_LIST:
      return { ...state, loading: true };
    case GET_CURRENCY_LIST_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case GET_CURRENCY_LIST_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default getCurencyListReducer;
